import * as moment from "moment";

export const showMovementRooms = (date?: Date) => {
    if(!date)
      return false;
    
    if(moment(date).isBefore(moment('2025-10-20')))
      return true;
    return false;
  }